module.exports = __webpack_public_path__ + "media/images/flags/fm-3bfd96ee5faa59b8017a192bff06f6d6.svg";